import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';
import unitsPropType from '../../propTypes/units';
import waveTimestepPropType from '../../propTypes/waveTimestep';
import windTimestepPropType from '../../propTypes/windTimestep';
import highlightTypePropType from '../../propTypes/forecastTableHighlightType';
import ForecastTableTimestep from './ForecastTableTimestep';

const dayClassName = (blurred) =>
  classNames({
    'sl-forecast-table__day': true,
    'sl-forecast-table__day--blurred': blurred,
  });

const ForecastTableDay = ({
  units,
  day,
  waveDay,
  windDay,
  blurred,
  expanded,
  hideSurfAndWind,
  filterTop3Swells,
  onClickDay,
  highlightType,
}) => (
  <tbody className={dayClassName(blurred)}>
    <ForecastTableTimestep
      key={day}
      units={units}
      label={day}
      wave={waveDay[waveDay.length / 2]}
      wind={windDay[windDay.length / 2]}
      onClick={onClickDay}
      isDay
      expanded={expanded}
      hideSurfAndWind={hideSurfAndWind}
      filterTop3Swells={filterTop3Swells}
      highlightType={highlightType}
    />
    {expanded
      ? [...Array(Math.max(waveDay.length, windDay.length))].map((_, timestep) => {
          const hour = 3 * timestep;
          const hour12 = hour % 12;
          const time = `${hour12 || 12}${hour > 11 ? 'PM' : 'AM'}`;
          // We have to duplicate the surf/swell data here manually since we only fetch 6 hour intervals
          const wave = waveDay[Math.floor(timestep / 2)];
          const wind = windDay[timestep];
          return (
            <ForecastTableTimestep
              key={time}
              units={units}
              label={time}
              wave={wave}
              wind={wind}
              hideSurfAndWind={hideSurfAndWind}
              filterTop3Swells={filterTop3Swells}
              highlightType={highlightType}
            />
          );
        })
      : null}
  </tbody>
);

ForecastTableDay.propTypes = {
  units: unitsPropType.isRequired,
  day: PropTypes.string.isRequired,
  waveDay: PropTypes.arrayOf(waveTimestepPropType).isRequired,
  windDay: PropTypes.arrayOf(windTimestepPropType).isRequired,
  blurred: PropTypes.bool,
  expanded: PropTypes.bool,
  hideSurfAndWind: PropTypes.bool,
  filterTop3Swells: PropTypes.bool,
  onClickDay: PropTypes.func,
  highlightType: highlightTypePropType.isRequired,
};

ForecastTableDay.defaultProps = {
  blurred: false,
  expanded: false,
  hideSurfAndWind: false,
  filterTop3Swells: false,
  onClickDay: null,
};

export default ForecastTableDay;
